import React from 'react';
import { Alert, Box, CircularProgress, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useGetWordPluginStatus } from '../../hooks/reactQuerys/WordPluginAccessQueries';

/**
 * Die Dokumentvorlagen gehören zum Word-Plugin (#1245) und sind nur für
 * freigeschaltete Benutzer da. Der Eintrag in der Seitenleiste ist dann schon
 * ausgeblendet; das hier fängt den direkten Aufruf über die Adresse ab, statt
 * die Seite in lauter 403-Fehler laufen zu lassen.
 */
export const WordPluginGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isWordPluginEnabled, isLoadingWordPluginStatus } =
    useGetWordPluginStatus();

  if (isLoadingWordPluginStatus) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isWordPluginEnabled) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity='info'>
          Die Dokumentvorlagen gehören zum Word-Plugin, das für Sie nicht
          freigeschaltet ist. Freischalten lässt es sich unter{' '}
          <Link component={RouterLink} to='/admin/dev/word-plugin'>
            /admin/dev/word-plugin
          </Link>
          .
        </Alert>
      </Box>
    );
  }

  return <>{children}</>;
};
